import { render, staticRenderFns } from "./MesaForm.vue?vue&type=template&id=65e4e4b2"
import script from "./MesaForm.vue?vue&type=script&lang=js"
export * from "./MesaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports